import { render, staticRenderFns } from "./addFbaSign.vue?vue&type=template&id=68e5fd8b&scoped=true&"
import script from "./addFbaSign.vue?vue&type=script&lang=js&"
export * from "./addFbaSign.vue?vue&type=script&lang=js&"
import style0 from "./addFbaSign.vue?vue&type=style&index=0&id=68e5fd8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5fd8b",
  null
  
)

export default component.exports